import { useLocation, useNavigate } from 'react-router-dom';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';

const ANALYTICS_TABS = [
  { key: '/analytics/scoring-rules', labelKey: 'lead_scoring.rules_title' },
  { key: '/analytics/lead-scores', labelKey: 'lead_scoring.scores_title' },
  { key: '/analytics/snapshots', labelKey: 'analytics_snapshot.title' },
  { key: '/analytics/forecasts', labelKey: 'forecast.title' },
];

export default function AnalyticsNav() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const activeKey = ANALYTICS_TABS.find(
    (tab) => location.pathname.startsWith(tab.key)
  )?.key ?? '/analytics/scoring-rules';

  return (
    <Tabs
      activeKey={activeKey}
      onChange={(key) => navigate(key)}
      items={ANALYTICS_TABS.map((tab) => ({
        key: tab.key,
        label: t(tab.labelKey),
      }))}
      style={{ marginBottom: 16 }}
    />
  );
}
